import { query } from '@angular/animations';
import { RIGHT_ARROW } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import {
    findHost,
    findLinkRaiz,
    findMbDevice,
    findMbRtu,
    findMbTelnet,
    findNodeLinkElementDescendancy,
    findSource,
    findMbBus,
    findMbTcp,
    findSwitch,
    updateMbDevice,
    updateMbRtu,
    updateHost,
    updateSource,
    updateMbTelnet,
    updateNodeLinkElement,
    updateMbTCP,
    updateSwitch,
    updateMbBus,
    createChildNodeLink,
    createRootNodeLink
} from './querys/querys';

@Injectable({
    providedIn: 'root'
})

export class fieldDataAdminService {

    constructor(private apollo: Apollo,
        private http: HttpClient) { }

    findLinkRaiz(): Observable<any> {
        return this.apollo.query<any>({
            query: findLinkRaiz,
            fetchPolicy: 'network-only'
        })
    }

    findNodeLinkElementDescendancy(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findNodeLinkElementDescendancy,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findMbTelnet(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findMbTelnet,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findMbDevice(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findMbDevice,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findMbRtuDevice(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findMbRtu,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findHost(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findHost,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findSource(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findSource,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findMbBus(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findMbBus,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findMbTcp(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findMbTcp,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }

    findSwitch(uuid: String): Observable<any> {
        return this.apollo.query<any>({
            query: findSwitch,
            variables: {
                uuid: uuid,
            },
            fetchPolicy: 'network-only'
        })
    }
    
    updateMbDeviceNull(uuid: String) {
        this.apollo.mutate<any>({
            mutation: updateMbDevice,
            variables: {
                uuid: uuid,
                address: null,
            },
        }).subscribe((data) => {

        });
    }

    updateMbRtuDeviceNull(uuid: String) {
        this.apollo.mutate({
            mutation: updateMbRtu,
            variables: {
                uuid: uuid,
                path: null
            }
        }).subscribe((data) => {

        });
    }

    updateHostNull(uuid: String){
        this.apollo.mutate<any>({
            mutation: updateHost,
            variables: {
                uuid: uuid,
                ip: null
            },
        }).subscribe((data) => {

        });
    }

    updateSourceNull(uuid: String){
        this.apollo.mutate<any>({
            mutation: updateSource,
            variables: {
                uuid: uuid,
                nombre: null,
                topic: null
            },
        }).subscribe((data) => {

        });
    }

    updateMbTelentNull(uuid: String){
        this.apollo.mutate<any>({
            mutation: updateMbTelnet,
            variables: {
                uuid: uuid,
                ip: null,
                port: null
            },
        }).subscribe((data) => {

        });
    }

    updateMbTcpNull(uuid: String){
        this.apollo.mutate<any>({
            mutation: updateMbTCP,
            variables: {
                uuid: uuid,
                port: null,
                host: null
            },
        }).subscribe((data) => {

        });
    }

    updateSwitchNull(uuid: String){
        this.apollo.mutate<any>({
            mutation: updateSwitch,
            variables: {
                uuid: uuid,
                nombre: null
            },
        }).subscribe((data) => {

        });
    }

    updateMbBusNull(uuid: String){
        this.apollo.mutate<any>({
            mutation: updateMbBus,
            variables: {
                uuid: uuid,
                baudRate: null,
                parity: null,
                dataBits: null,
                stopBits: null,
                timeout: null,
                wait: null
            }
        }).subscribe((data) => {

        });
    }

    updateMbDevice(row: any) {
        this.apollo.mutate<any>({
            mutation: updateMbDevice,
            variables: {
                uuid: row.uuid,
                address: row.address,
            },
        }).subscribe((data) => {

        });
    }

    updateMbRtuDevice(dispositivo) {
        this.apollo.mutate({
            mutation: updateMbRtu,
            variables: {
                uuid: dispositivo.uuid,
                path: dispositivo.path
            }
        }).subscribe((data) => {

        });
    }

    updateHost(row: any){
        this.apollo.mutate<any>({
            mutation: updateHost,
            variables: {
                uuid: row.uuid,
                ip: row.ip
            },
        }).subscribe((data) => {

        });
    }

    updateSource(row: any){
        this.apollo.mutate<any>({
            mutation: updateSource,
            variables: {
                uuid: row.uuid,
                nombre: row.nombre,
                topic: row.topic
            },
        }).subscribe((data) => {

        });
    }

    updateNodeLinkElement(row: any): Observable<any>{
        return this.apollo.mutate<any>({
            mutation: updateNodeLinkElement,
            variables: {
                uuid: row.uuid,
                nombre: row.nombre,
                labels: row.labels
            },
        });
    }

    updateMbTelent(row: any){
        this.apollo.mutate<any>({
            mutation: updateMbTelnet,
            variables: {
                uuid: row.uuid,
                ip: row.ip,
                port: row.port
            },
        }).subscribe((data) => {

        });
    }

    updateMbTcp(row: any){
        this.apollo.mutate<any>({
            mutation: updateMbTCP,
            variables: {
                uuid: row.uuid,
                port: row.port,
                host: row.host
            },
        }).subscribe((data) => {

        });
    }

    updateSwitch(row: any){
        this.apollo.mutate<any>({
            mutation: updateSwitch,
            variables: {
                uuid: row.uuid,
                nombre: row.nombre
            },
        }).subscribe((data) => {

        });
    }

    updateMbBus(row: any){
        this.apollo.mutate<any>({
            mutation: updateMbBus,
            variables: {
                uuid: row.uuid,
                baudRate: row.baudRate,
                parity: row.parity,
                dataBits: row.dataBits,
                stopBits: row.stopBits,
                timeout: row.timeout,
                wait: row.wait
            }
        }).subscribe((data) => {

        });
    }

    createChildNodeLink(row: any, parentId: any): Observable<any>{
        return this.apollo.mutate<any>({
            mutation: createChildNodeLink,
            variables: {
                uuid: parentId,
                nombre: row.nombre,
                labels: row.labels
            },
        })
    }

    createRootNodeLink(row: any): Observable<any>{
        return this.apollo.mutate<any>({
            mutation: createRootNodeLink,
            variables: {
                nombre: row.nombre,
                labels: row.labels
            },
        })
    }
}
